<template>
    <b-card-text>
        <b-row class="p-2">
            <b-button-group>
                <b-button @click="filterResults('#', 1)">#</b-button>
                <b-button
                    :key="index"
                    v-for="(value, index) in buttons"
                    :class="{ active: data.char == value }"
                    @click="filterResults(value, 1)"
                    >{{ value }}</b-button
                >
            </b-button-group>
        </b-row>
        <div v-if="!loaded">
            <loader />
        </div>
        <div v-if="loaded">
            <b-row class="p-3">
                <b-col>
                    <strong>Name:</strong>
                </b-col>
                <b-col>
                    <strong>Home:</strong>
                </b-col>
                <b-col>
                    <strong>Work:</strong>
                </b-col>
                <b-col>
                    <strong>Mobile:</strong>
                </b-col>
                <b-col>
                    <strong>Address:</strong>
                </b-col>
                <b-col>
                    <strong>City:</strong>
                </b-col>
                <b-col sm="2">
                    <strong>Pets:</strong>
                </b-col>
                <b-col sm="1">
                    <strong>Status:</strong>
                </b-col>
            </b-row>
            <div v-if="resources.list.length > 0">
                <b-row
                    :key="item.id"
                    v-for="item in resources.list"
                    class="border-bottom p-2"
                >
                    <b-col>
                        <b-link
                            :to="{
                                name: 'client_profile',
                                params: { id: item.encoded_id }
                            }"
                            >{{ item.lastname }}, {{ item.firstname }}</b-link
                        >
                    </b-col>
                    <b-col>
                        <b-link :href="'tel:' + item.home">{{
                            item.home
                        }}</b-link>
                    </b-col>
                    <b-col>
                        <b-link :href="'tel:' + item.work">{{
                            item.work
                        }}</b-link>
                    </b-col>
                    <b-col>
                        <b-link :href="'tel:' + item.mobile">{{
                            item.mobile
                        }}</b-link>
                    </b-col>
                    <b-col>{{ item.address }}</b-col>
                    <b-col>{{ item.city }}</b-col>
                    <b-col v-if="item.patients.length" sm="2">
                        <a
                            v-for="(patient, index) in item.patients"
                            :key="patient.id"
                            :href="patient.ci_url"
                            >{{
                                getPatientName(
                                    patient,
                                    index,
                                    item.patients.length
                                )
                            }}</a
                        >
                    </b-col>
                    <b-col v-else sm="2"></b-col>
                    <b-col sm="1">{{ getClientStatus(item) }}</b-col>
                </b-row>
            </div>
            <div v-else>
                <b-row class="border-bottom p-2">
                    <b-col>
                        <i>No records available</i>
                    </b-col>
                </b-row>
            </div>

            <b-pagination
                v-if="meta"
                v-show="meta.lastPage > 1"
                class="vet-pagination"
                align="right"
                v-model="meta.currentPage"
                :total-rows="meta.total"
                :per-page="meta.perPage"
                prev-text="Prev"
                next-text="Next"
                :hide-goto-end-buttons="true"
                @change="changePage"
            />
        </div>
    </b-card-text>
</template>

<script>
import { range } from "lodash";
export default {
    components: {
        Loader: () => import("@/components/elements/loader-list")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    status: 0,
                    char: "A"
                };
            }
        }
    },
    data() {
        return {
            loaded: false,
            buttons: [],
            resources: {
                list: []
            },
            meta: null
        };
    },
    mounted() {
        this.renderFilterButtons();
        this.data.status = 0;
        this.data.char = "A";

        return this._getSetting().then(() => {
            let self = this;
            self.init();
            self.$root.$on("filter-client-dashboard-list:refresh", function (
                params
            ) {
                if (params) {
                    self.data.status = params.status;
                }

                self.init();
            });
        });
    },
    methods: {
        init() {
            this.loaded = false;
            this.filterResults();
        },
        renderFilterButtons() {
            this.buttons = range(
                "A".charCodeAt(0),
                "Z".charCodeAt(0) + 1
            ).map(i => String.fromCharCode(i));
        },
        filterResults(char, page) {
            let self = this;
            self.loaded = false;

            if (char) {
                self.data.char = char;
            }

            return self.$http
                .get(process.env.BARRACUDA + "actor/client", {
                    params: {
                        perPage: 50,
                        status: self.data.status ? self.data.status : 0,
                        prefix: self.data.char ? self.data.char : "A",
                        page: page ? page : 1
                    }
                })
                .then(response => {
                    if (response.status === 200) {
                        this.resources.list =
                            response.data.response.resource.data;
                        this.meta = response.data.response.meta;
                    } else {
                        this._message("Error loading data", "danger");
                    }
                })
                .finally(() => {
                    this.loaded = true;
                });
        },
        changePage(nextPage) {
            this.filterResults(this.data.char, nextPage);
        },
        getPatientName(data, index, size) {
            size = size - 1;
            var pet_name = "";

            pet_name += data.name;

            if (data.patient_status && data.patient_status.id != 1) {
                pet_name += " (" + data.patient_status.name + ")";
            }

            if (index !== size) {
                pet_name += ", ";
            }

            return pet_name;
        },
        getClientStatus(data) {
            if (data.actor_status_id === 2) {
                return (
                    "Inactive (" +
                    moment
                        .unix(data.actor_status_date)
                        .tz(this._timeZone)
                        .format(this.getDateFormat()) +
                    ")"
                );
            }

            return "Active";
        }
    }
};
</script>
<style>
li a {
    cursor: pointer;
}
</style>
